module.exports = __webpack_public_path__ + "img/logo_fisioviajante.bffd2090.webp";